<ng-template #collEditorTemplate style="background-color:burlywood">
<div class="modal-header headerBackground">
  <h4 class="modal-title pull-left ">Add to Collection</h4>
  <button type="button " class="close pull-right" aria-label="Close" (click)="modalRef.hide();">
    <span aria-hidden="true ">&times;</span>
  </button>
</div>
<div class="row padding-1">
    <div [class]="objectTypeClass">
    <div class="input-group mb-3">
    <input #iesearch [(ngModel)]="objectRegistrySearchText" type="text" class="form-control" [placeholder]="searchText" aria-describedby="search"
      (focus)="showRemoveSearch(null);" (keyup.enter)="objectRegistrySearchTextChange()" />
    <div class="input-group-append" (click)="removeSearchValueCollection()">
      <button class="btn btn-sm btn-outline-secondary" id="search"  type="submit" (click)="objectRegistrySearchTextChange()">
        <i id="button_Search"></i>
      </button>
    </div>
  </div>
</div>
<div *ngIf="!isAttributeSets" class="form-group col-md-6" [style]="objectTypeStyle">
    <div>
      <label>ObjectType</label>
    </div>
    <select class="form-control"
      (change)="objectTypeChange(ieoptioncol.value)"
      #ieoptioncol>
      <option *ngFor="let option of objectRegistryTypes" [value]="option.ObjectTypeDID">
      {{option.DisplayName}}</option>
    </select>
  </div>
</div>
<div class="row  padding-1">
  <div class="col-md-12">
    <div class="table-responsive">
      <table class="table table-sm table-striped">
        <thead class="thead-dark">
          <tr>
            <th scope="col">
              Displayname
            </th>
          </tr>
        </thead>
        <tbody id="ObjectRegistryItems">
          <tr scope="row" *ngFor="let orItem of objectRegistryItems.value; let i = index;" [class.table-danger]="i==selectedRowCol" (click)="setActiveRowCol(i)">
            <td>{{orItem.DisplayName}}
            </td>
          </tr>
        </tbody>
      </table>
      <div class="pager-pos" *ngIf="(objectRegistryItems.rowCount>objectRegistryItems.rowsPerPage )">
        <ngb-pagination #currentPageCollection [collectionSize]="objectRegistryItems.rowCount" [(page)]="objectRegistryItems.activePage" [pageSize]="objectRegistryItems.rowsPerPage"
        [boundaryLinks]="true" size="sm" (pageChange)="objectRegistryPageChange(currentPageCollection);"></ngb-pagination>
      </div>

      <div class="btn-sm">
          <button type="button" (click)="addToCollection();modalRef.hide()" class="btn btn-warning btn-sm">
              Add to Collection
          </button>
      </div>
  </div>
  </div>
</div>
</ng-template>
